export const SHIFT4_BLUE = '#2253ff'
export const BLACK_COLOR = '#000000'
export const GRAY_COLOR = '#333333'
export const LIGHT_GRAY_COLOR = '#999999'
export const WHITE_COLOR = '#ffffff'
